import axios from "axios";
import {URLAPISUBIDA, URLCARPETADESTINO} from "./Contantes";
import {subirMultiplesImagenHostingFile} from "./subirMultiplesImagenHostingFile";

export const subirMultiplesImagenHostingArray = async ({arrObj = [], dato = 'img'}) => {


    let arr = []
    for (let i = 0; i < arrObj.length; i++) {
        let img = await subirImagen(arrObj[i][dato], i)
        let obj = {
            ...arrObj[i],
            [dato]: img
        }
        arr.push(obj)
    }

    return arr




}

const subirImagen = (file, i) => {

    return new Promise(resolve => {


        if (!file) {
            return resolve(file)
        }

        if (typeof file === 'string') {
            return resolve(file)

        } else {



            let newFile = new File([file], file.name+1, {type: file.type})

            const formData = new FormData();
            formData.append('img', newFile);

            axios.post(URLAPISUBIDA, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(response => {
                    return resolve(URLCARPETADESTINO + response.data.file_path)
                    // Handle successful upload response
                })
                .catch(error => {
                    return resolve(error.message)
                });


        }
    })
}
